export const environment = {
    BUILD_PRODUCT: "account",
    API_URL_BASE: "https://api.12082026.xyz/",
    API_LOGIN_URL: "v1/users/login",
    API_REGISTER_URL: "v1/users/register",
    API_ACTIVATE_EMAIL_URL: "v1/users/activate",
    API_ACTIVATE_EMAIL_RESEND_URL: "v1/users/resend-activation-email",
    API_FORGOT_PASSWORD_URL: "v1/users/password-reset/init",
    API_FORGOT_PASSWORD_FINISH_URL: "v1/users/password-reset/finish",
    API_GET_KITCHEN_INVITATION: "v1/public/invitations/kitchen/{{id}}",
    API_POST_KITCHEN_INVITATION_CONFIRM: "v1/users/register-invitation",
    PRODUCT_URLS: {
        LANDING_PAGE: "https://12082026.xyz",
        USER_APP: "https://app.12082026.xyz",
        RESTAURANT: "https://restaurant.12082026.xyz",
        DRIVER: "https://driver.12082026.xyz",
        ADMIN: "https://admin.12082026.xyz"
    },
    DEBUG_STAGING_BADGE: true
};
